import React, { createContext, useContext, useState, useEffect } from "react";

const dict = {
  fr: {
    nav: {
      treatments: "Soins",
      yacht: "Yachts",
      villa: "Villa & Conciergerie",
      xp: "Notre Thérapie",
      exomobil: "Exomobil",
      booking: "Réserver",
      partners: "Partenaires",
      investors: "Investisseurs",
    },
    cta: {
      book_vip: "Réserver une session VIP",
      contact_wa: "Contact WhatsApp",
      explore: "Explorer",
      learn_more: "En savoir plus",
    },
    home: {
      eyebrow: "MONACO · FRENCH RIVIERA",
      hero_title: "La récupération haute performance, livrée à votre adresse.",
      hero_sub: "Thérapie par ondes de choc, décompression, biohacking. Pour yachts, athlètes et clientèle privée à Monaco et sur la Côte d'Azur.",
      available: "Disponible à Monaco, Cala del Forte, Cannes & Saint-Tropez · yachts, villas privées & événements privés",
      treatments_title: "Protocoles signature",
      treatments_sub: "Une médecine de récupération discrète, opérée par des cliniciens et délivrée dans des espaces choisis : suite hôtel, villa, yacht.",
      yacht_title: "Service à bord",
      yacht_sub: "Un protocole pensé pour les équipages et propriétaires. Livraison sous 90 minutes en marina.",
      gp_title: "Monaco Grand Prix",
      gp_sub: "Une cellule mobile dédiée aux pilotes, équipes et invités VIP durant le week-end du Grand Prix.",
      tech_title: "Technologies XP & Exomobil",
      tech_sub: "Une plateforme de soins mobile, instrumentée et silencieuse. La performance, en toute discrétion.",
      metrics_title: "Mesures de récupération",
      partners_title: "Confiance",
      testimonials_title: "Témoignages",
      pricing_title: "Tarifs",
      pricing_sub: "Sur devis pour groupes, équipages et événements.",
      contact_title: "Demander une session",
      contact_sub: "Réponse VIP sous 24h. Confidentialité absolue.",
      investor_cta: "Espace Investisseurs",
    },
    form: {
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      service: "Soin souhaité",
      date: "Date préférée",
      time: "Créneau",
      location: "Lieu (Monaco, yacht, villa…)",
      message: "Message",
      submit: "Envoyer ma demande",
      success: "Merci. Notre équipe VIP vous recontacte sous 24h.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      required: "Veuillez renseigner les champs requis.",
    },
    stats: {
      sessions: "Sessions",
      satisfaction: "Satisfaction",
      crew_yachts: "Équipages yachts",
      riviera_cities: "Villes Riviera",
      pain_reduction: "Réduction douleur",
      rom_gain: "Gain mobilité",
      crew_uptime: "Disponibilité équipage",
      return_rate: "Taux de retour",
      drivers: "Pilotes",
      teams: "Écuries",
      vip: "Invités VIP",
      mobility: "Mobilité",
      tech: "Technologie",
      network: "Réseau",
      trusted_by: "Ils nous font confiance",
      partnership_banner: "En partenariat avec le Centre médical MedMaiora de Cala del Forte",
    },
    footer: {
      tagline: "Récupération mobile haute performance — Monaco & French Riviera",
      legal: "© 2026 Riviera Shockwaves. Tous droits réservés.",
      admin: "Administration",
      investors: "Investisseurs",
    },
  },
  en: {
    nav: {
      treatments: "Treatments",
      yacht: "Yachts",
      villa: "Villa & Concierge",
      xp: "Our Therapy",
      exomobil: "Exomobil",
      booking: "Book",
      partners: "Partners",
      investors: "Investors",
    },
    cta: {
      book_vip: "Book a VIP session",
      contact_wa: "WhatsApp",
      explore: "Explore",
      learn_more: "Learn more",
    },
    home: {
      eyebrow: "MONACO · FRENCH RIVIERA",
      hero_title: "High-performance recovery, delivered to you.",
      hero_sub: "Shockwave therapy, decompression, biohacking. For yachts, athletes and private clients across Monaco and the Riviera.",
      available: "Available in Monaco, Cala del Forte, Cannes & Saint-Tropez · yachts, private villas & private events",
      treatments_title: "Signature protocols",
      treatments_sub: "Discreet recovery medicine operated by clinicians, delivered in your chosen environment: hotel suite, villa, yacht.",
      yacht_title: "Yacht service",
      yacht_sub: "A protocol designed for crew and owners. Marina delivery within 90 minutes.",
      gp_title: "Monaco Grand Prix",
      gp_sub: "A mobile unit dedicated to drivers, teams and VIP guests during the GP weekend.",
      tech_title: "Technologies",
      tech_sub: "A mobile, instrumented, silent care platform. Performance, in absolute discretion.",
      metrics_title: "Recovery metrics",
      partners_title: "Trusted by",
      testimonials_title: "Testimonials",
      pricing_title: "Pricing",
      pricing_sub: "On-quote for groups, crews and events.",
      contact_title: "Request a session",
      contact_sub: "VIP reply within 24h. Absolute discretion.",
      investor_cta: "Investor Mode",
    },
    form: {
      name: "Full name",
      email: "Email",
      phone: "Phone",
      service: "Desired treatment",
      date: "Preferred date",
      time: "Preferred time",
      location: "Location (Monaco, yacht, villa…)",
      message: "Message",
      submit: "Send request",
      success: "Thank you. Our VIP team will reply within 24h.",
      error: "An error occurred. Please try again.",
      required: "Please fill in required fields.",
    },
    stats: {
      sessions: "Sessions",
      satisfaction: "Satisfaction",
      crew_yachts: "Crew yachts",
      riviera_cities: "Riviera cities",
      pain_reduction: "Pain reduction",
      rom_gain: "ROM gain",
      crew_uptime: "Crew uptime",
      return_rate: "Return rate",
      drivers: "Drivers",
      teams: "Teams",
      vip: "VIP Guests",
      mobility: "Mobility",
      tech: "Tech",
      network: "Network",
      trusted_by: "Trusted by",
      partnership_banner: "In partnership with the Cala del Forte MedMaiora Medical Center",
    },
    footer: {
      tagline: "High-performance mobile recovery — Monaco & French Riviera",
      legal: "© 2026 Riviera Shockwaves. All rights reserved.",
      admin: "Admin",
      investors: "Investors",
    },
  },
  it: {
    nav: {
      treatments: "Trattamenti",
      yacht: "Yacht",
      villa: "Villa & Concierge",
      xp: "La nostra terapia",
      exomobil: "Exomobil",
      booking: "Prenota",
      partners: "Partner",
      investors: "Investitori",
    },
    cta: {
      book_vip: "Prenota una sessione VIP",
      contact_wa: "Contatto WhatsApp",
      explore: "Esplora",
      learn_more: "Scopri di più",
    },
    home: {
      eyebrow: "MONACO · COSTA AZZURRA",
      hero_title: "Il recupero ad alte prestazioni, consegnato al tuo indirizzo.",
      hero_sub: "Onde d'urto, decompressione, biohacking. Per yacht, atleti e clientela privata a Monaco e sulla Costa Azzurra.",
      available: "Disponibile a Monaco, Cala del Forte, Cannes e Saint-Tropez · yacht, ville private ed eventi privati",
      treatments_title: "Protocolli signature",
      treatments_sub: "Medicina di recupero discreta, gestita da clinici e consegnata negli spazi che scegli: suite hotel, villa, yacht.",
      yacht_title: "Servizio a bordo",
      yacht_sub: "Un protocollo pensato per equipaggi e armatori. Consegna entro 90 minuti in marina.",
      gp_title: "Monaco Grand Prix",
      gp_sub: "Un'unità mobile dedicata a piloti, scuderie e ospiti VIP durante il weekend del GP.",
      tech_title: "Tecnologie XP & Exomobil",
      tech_sub: "Una piattaforma di cura mobile, strumentata e silenziosa. La performance, in piena discrezione.",
      metrics_title: "Misure di recupero",
      partners_title: "Fiducia",
      testimonials_title: "Testimonianze",
      pricing_title: "Tariffe",
      pricing_sub: "Su preventivo per gruppi, equipaggi ed eventi.",
      contact_title: "Richiedi una sessione",
      contact_sub: "Risposta VIP entro 24h. Riservatezza assoluta.",
      investor_cta: "Area Investitori",
    },
    form: {
      name: "Nome completo",
      email: "Email",
      phone: "Telefono",
      service: "Trattamento desiderato",
      date: "Data preferita",
      time: "Orario",
      location: "Luogo (Monaco, yacht, villa…)",
      message: "Messaggio",
      submit: "Invia richiesta",
      success: "Grazie. Il nostro team VIP ti ricontatterà entro 24h.",
      error: "Si è verificato un errore. Riprova.",
      required: "Compila i campi richiesti.",
    },
    stats: {
      sessions: "Sessioni",
      satisfaction: "Soddisfazione",
      crew_yachts: "Equipaggi yacht",
      riviera_cities: "Città Riviera",
      pain_reduction: "Riduzione dolore",
      rom_gain: "Guadagno mobilità",
      crew_uptime: "Disponibilità equipaggio",
      return_rate: "Tasso di ritorno",
      drivers: "Piloti",
      teams: "Scuderie",
      vip: "Ospiti VIP",
      mobility: "Mobilità",
      tech: "Tecnologia",
      network: "Rete",
      trusted_by: "Ci scelgono",
      partnership_banner: "In collaborazione con il Centro Medico MedMaiora di Cala del Forte",
    },
    footer: {
      tagline: "Recupero mobile ad alte prestazioni — Monaco & Costa Azzurra",
      legal: "© 2026 Riviera Shockwaves. Tutti i diritti riservati.",
      admin: "Admin",
      investors: "Investitori",
    },
  },
  ru: {
    nav: {
      treatments: "Процедуры",
      yacht: "Яхты",
      villa: "Вилла & консьерж",
      xp: "Наша терапия",
      exomobil: "Exomobil",
      booking: "Записаться",
      partners: "Партнёры",
      investors: "Инвесторы",
    },
    cta: {
      book_vip: "VIP-сеанс",
      contact_wa: "WhatsApp",
      explore: "Узнать",
      learn_more: "Подробнее",
    },
    home: {
      eyebrow: "МОНАКО · ЛАЗУРНЫЙ БЕРЕГ",
      hero_title: "Высокоэффективное восстановление с выездом к вам.",
      hero_sub: "Ударно-волновая терапия, декомпрессия, биохакинг. Для яхт, спортсменов и частных клиентов в Монако и на Лазурном берегу.",
      available: "Монако, Кала-дель-Форте, Канны и Сен-Тропе · яхты, частные виллы и частные мероприятия",
      treatments_title: "Сигнатурные протоколы",
      treatments_sub: "Деликатная восстановительная медицина под управлением клиницистов, оказываемая в выбранных вами условиях: люкс отеля, вилла, яхта.",
      yacht_title: "Сервис на борту",
      yacht_sub: "Протокол для экипажей и владельцев. Прибытие в марину в течение 90 минут.",
      gp_title: "Гран-при Монако",
      gp_sub: "Мобильное подразделение для пилотов, команд и VIP-гостей в течение уик-энда Гран-при.",
      tech_title: "Технологии",
      tech_sub: "Мобильная инструментированная и бесшумная платформа ухода. Эффективность при полной конфиденциальности.",
      metrics_title: "Показатели восстановления",
      partners_title: "Доверие",
      testimonials_title: "Отзывы",
      pricing_title: "Тарифы",
      pricing_sub: "По запросу для групп, экипажей и мероприятий.",
      contact_title: "Запросить сеанс",
      contact_sub: "VIP-ответ в течение 24 часов. Полная конфиденциальность.",
      investor_cta: "Инвесторам",
    },
    form: {
      name: "Полное имя",
      email: "Email",
      phone: "Телефон",
      service: "Желаемая процедура",
      date: "Дата",
      time: "Время",
      location: "Место (Монако, яхта, вилла…)",
      message: "Сообщение",
      submit: "Отправить запрос",
      success: "Спасибо. Наша VIP-команда свяжется с вами в течение 24 часов.",
      error: "Произошла ошибка. Попробуйте ещё раз.",
      required: "Заполните обязательные поля.",
    },
    stats: {
      sessions: "Сеансы",
      satisfaction: "Удовлетворённость",
      crew_yachts: "Яхт-экипажи",
      riviera_cities: "Города Ривьеры",
      pain_reduction: "Снижение боли",
      rom_gain: "Прирост подвижности",
      crew_uptime: "Доступность экипажа",
      return_rate: "Возвратность",
      drivers: "Пилоты",
      teams: "Команды",
      vip: "VIP-гости",
      mobility: "Мобильность",
      tech: "Технология",
      network: "Сеть",
      trusted_by: "Нам доверяют",
      partnership_banner: "В партнёрстве с медицинским центром MedMaiora в Кала-дель-Форте",
    },
    footer: {
      tagline: "Мобильное восстановление премиум-класса — Монако и Лазурный берег",
      legal: "© 2026 Riviera Shockwaves. Все права защищены.",
      admin: "Админ",
      investors: "Инвесторы",
    },
  },
};

const LangContext = createContext({ lang: "fr", setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("riviera_lang") || "fr");
  useEffect(() => { localStorage.setItem("riviera_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (path) => {
    const keys = path.split(".");
    let cur = dict[lang] || dict.fr;
    for (const k of keys) { if (cur && cur[k] !== undefined) cur = cur[k]; else return path; }
    return cur;
  };
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
